import { AdapterBase, RunResponse, RunResponseType } from "../../storyV2/adapter/AdapterBase";
import { StoryNodeType } from "../../storyV2/domain/StoryNodeType";
import { RunStreamResponse } from "../../storyV2/function/FunctionBase";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
import { ImageModel } from "../../storyV2/model/ImageModel";
import { tryPromise, TryResult } from "../../cutil/LangUtil";
import { EdgeState } from "../../storyV2/domain/StoryEdge";
import { AdapterErrorUtil } from "../../storyV2/adapter/AdapterErrorUtil";
export class ImageGenAdapter extends AdapterBase {
    async run(story, edge, sourceNode, actionData) {
        if (sourceNode === undefined) {
            return Promise.reject();
        }
        await this.globalContextUpdateQuery(story, sourceNode, edge);
        switch (sourceNode.options.type) {
            case StoryNodeType.CUSTOMGROUP:
                const children = sourceNode.children ?? [];
                let edgeStreamResponse = {
                    values: children.map(x => x.content ?? ""),
                    streamResponse: new RunStreamResponse(),
                };
                this.runAll(story, edge, sourceNode, actionData, children, edgeStreamResponse.streamResponse);
                return new RunResponse(RunResponseType.IMAGE_GROUP, edgeStreamResponse);
            case StoryNodeType.CUSTOMNODE:
                const res = await tryPromise(this.runSingle(sourceNode.content, actionData, story, edge, sourceNode));
                if (res.error) {
                    return new RunResponse(RunResponseType.ERROR, AdapterErrorUtil.getErrorMsg(res));
                }
                return new RunResponse(RunResponseType.IMAGE, res.data);
        }
    }
    async runSingle(input, actionData, story, edge, sourceNode) {
        const res = await FunctionUtil.findFuncAndRun(input, actionData, this.funcRegistry, FunctionUtil.createFuncVariables(story, edge), { projectId: story.projectId, edgeId: edge.options.id }, () => edge.state === EdgeState.ERROR, sourceNode);
        return new ImageModel(input, res.data);
    }
    async runAll(story, edge, sourceNode, actionData, nodes, edgeStreamResponse) {
        const map = new Map();
        const requestArr = nodes.map((value, index, array) => {
            const request = this.runSingle(value.content, actionData, story, edge, sourceNode)
                .then(res => {
                map.set(index, new TryResult(res, undefined));
                let completion = false;
                if (map.size === nodes.length) {
                    completion = true;
                }
                edgeStreamResponse.receive(map, completion);
                return Promise.resolve();
            })
                .catch(error => {
                map.set(index, new TryResult(undefined, error));
                let completion = false;
                if (map.size === nodes.length) {
                    completion = true;
                }
                edgeStreamResponse.receive(map, completion);
                return Promise.resolve();
            });
            return request;
        });
        return Promise.all(requestArr).then(() => {
            return Promise.resolve();
        });
    }
}
